(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementSection = document.querySelector('.announcement-bar-section');
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.handleDesktopChange.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.desktopQuery.addEventListener('change', this.onResizeHandler);

      if (this.desktopQuery.matches) {
        this.enableDesktopSticky();
      } else {
        this.disableDesktopSticky();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    handleDesktopChange() {
      this.setHeaderHeight();

      if (this.desktopQuery.matches) {
        this.enableDesktopSticky();
      } else {
        this.disableDesktopSticky();
      }
    }

    enableDesktopSticky() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disableDesktopSticky() {
      window.removeEventListener('scroll', this.onScrollHandler);

      this.setAnnouncementVisible(false);

      this.header.classList.remove(
        'scrolled-past-header',
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.desktopQuery.removeEventListener('change', this.onResizeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    setAnnouncementVisible(visible) {
      if (!this.announcementSection || !this.desktopQuery.matches) {
        this.header.classList.remove('gf-sticky-announcement-visible');
        return;
      }

      if (visible) {
        const announcementHeight = this.announcementSection.offsetHeight;
        const groupHeight = announcementHeight + this.header.offsetHeight;
        document.documentElement.style.setProperty('--gf-sticky-announcement-height', `${announcementHeight}px`);
        document.documentElement.style.setProperty('--gf-sticky-group-height', `${groupHeight}px`);
        this.announcementSection.classList.add('gf-sticky-with-header-visible');
        this.header.classList.add('gf-sticky-announcement-visible');
      } else {
        this.announcementSection.classList.remove('gf-sticky-with-header-visible');
        this.header.classList.remove('gf-sticky-announcement-visible');
      }
    }

    onScroll() {
      if (!this.desktopQuery.matches) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.setAnnouncementVisible(false);
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.header.matches(':hover')) {
  this.closeMenuDisclosure();
}
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.setAnnouncementVisible(true);
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.setAnnouncementVisible(false);
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
